<template>
  <div>
    <transition name="fade-bottom">
      <div v-if="showCookiesBar" class="cookies-bar" :style="{ background: primaryColor }">
        <div class="message">
          <p :style="{ color: secondaryColor }"><slot name="message-text">By using this website, you agree to our</slot> <button type="button" data-toggle="modal" data-target="#modal-policy" class="link-underline" :style="{ color: secondaryColor }"><slot name="message-button">cookies policy</slot></button>.</p>
        </div>

        <div class="buttons">
          <button type="button" @click="acceptAll" class="btn" :style="{ color: secondaryColor }"><slot name="message-btn-confirm">OK I CONFIRM</slot></button>
          <button type="button" @click="showModal('modal-cookies')" class="btn-underline" :style="{ color: secondaryColor, borderColor: secondaryColor }"><slot name="message-btn-change">CHANGE SETTINGS</slot></button>
        </div>
      </div>
    </transition>

    <div id="modal-cookies" class="modal fade" tabindex="-1" aria-labelledby="modal-cookies-label" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-body-content">
              <p class="cookies-title">
                <slot name="settings-title">Cookies Settings</slot>
              </p>

              <!-- necessary -->
              <button type="button" class="btn-accept-decline accept" disabled>
                <div class="btn-accept-decline-switch" :style="{ borderColor: primaryColor, color: primaryColor }">
                  <span class="switch-label switch-label-left">{{ langs.on }}</span>
                  <span class="switch-label switch-label-right">{{ langs.off }}</span>
                </div>

                <div class="descr" :style="{ color: primaryColor }">
                  <p class="descr-title">
                    <slot name="necessary-title">Strictly necessary and performance cookies</slot>
                  </p>
                  <p class="descr-text">
                    <slot name="necessary-descr">These cookies remember choices you make to improve your experience. This information is not used for advertising on other sites.</slot>
                  </p>
                </div>
              </button>

              <!-- statistics -->
              <button type="button" class="btn-accept-decline" :class="{ 'accept': cookies.statistics, 'decline': !cookies.statistics }" @click="cookies.statistics = !cookies.statistics">
                <div class="btn-accept-decline-switch" :style="{ borderColor: primaryColor, color: primaryColor }">
                  <span class="switch-label switch-label-left">{{ langs.on }}</span>
                  <span class="switch-label switch-label-right">{{ langs.off }}</span>
                </div>

                <div class="descr" :style="{ color: primaryColor }">
                  <p class="descr-title">
                    <slot name="statistics-title"></slot>
                  </p>
                  <p class="descr-text">
                    <slot name="statistics-descr"></slot>
                  </p>
                </div>
              </button>

              <!-- marketing -->
              <button type="button" class="btn-accept-decline" :class="{ 'accept': cookies.marketing, 'decline': !cookies.marketing }" @click="cookies.marketing = !cookies.marketing">
                <div class="btn-accept-decline-switch" :style="{ borderColor: primaryColor, color: primaryColor }">
                  <span class="switch-label switch-label-left">{{ langs.on }}</span>
                  <span class="switch-label switch-label-right">{{ langs.off }}</span>
                </div>

                <div class="descr" :style="{ color: primaryColor }">
                  <p class="descr-title">
                    <slot name="marketing-title"></slot>
                  </p>
                  <p class="descr-text">
                    <slot name="marketing-descr"></slot>
                  </p>
                </div>
              </button>

              <div class="btn-save-wrapper">
                <button type="button" class="btn-save-cookies" :style="{ background: primaryColor, color: secondaryColor }" data-bs-dismiss="modal" @click="sendCookiesSelection()"><slot name="btn-save">save & close</slot></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-policy" class="modal modal-pattern fade" tabindex="-1" aria-labelledby="modal-cookies-label" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-modal-close" data-dismiss="modal">×</button>
          </div>

          <div class="modal-body">
            <div class="modal-body-content">
              <p class="cookies-title">
                <slot name="policy-title">Cookies Policy</slot>
              </p>

              <div class="lh-16">
                <slot name="policy-descr">
                  <p>We use “cookies” to facilitate the use of our website. Cookies are small text files that are stored by your browser on your device and are necessary for the use of our website. We use cookies to understand better how our website is used and to improve website navigation. The cookies we use do not store personal data or personal information that may lead to identification of the person to whom they relate and which has been collected by other means. If you do not wish us to collect information via cookies, please set up your internet browser to delete all existing cookies from your computer’s hard drive, block all cookies in the future and receive a warning before saving a cookie. More detailed information can be found in your browser's operating settings.</p>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bsModal from 'bootstrap/js/dist/modal';
import axios from 'axios';

const _getCsrfTokenUrl = '/'+window.Laravel.code+'/get/csrf';
const _setCookiesPref = '/'+window.Laravel.code+'/setcookies/pref';

export default {
  props: {
    langs: {
      type: Object,
      required: false,
      default: {
        on: 'on',
        off: 'off',
      }
    },
    primaryColor: {
      type: String,
      required: false,
      default: "#000"
    },
    secondaryColor: {
      type: String,
      required: false,
      default: "#fff"
    },
    cookiesopt: {
      type: Object,
      required: true,
      default: () => ({
        necessary: true,
        statistics: false,
        marketing: false
      })
    }
  },
  data() {
    return {
      showCookiesBar: this.frequencyCookieExpired(),
      cookies: this.cookiesopt,
      modals: [],
    }
  },
  methods: {
    acceptAll() {
      this.cookies = {
        necessary: true,
        statistics: true,
        marketing: true
      };
      this.sendCookiesSelection();
    },
    sendCookiesSelection(){
      const component = this;
      axios.get(_getCsrfTokenUrl)
          .then(response => {
            var _token = response.data._token;
            axios.defaults.headers.common = { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': _token };
            axios
              .post(_setCookiesPref, component.cookies)
              .then(function (success) {
                try {
                    gtag('consent', 'update', {
                      // standard
                      'functionality_storage': component.cookies.necessary? 'granted' : 'denied',

                      // Analytics
                      'analytics_storage': component.cookies.statistics?'granted':'denied',

                      // Ads
                      'ad_storage': component.cookies.marketing?'granted':'denied',
                      'ad_user_data': component.cookies.marketing?'granted':'denied',
                      'ad_personalization': component.cookies.marketing?'granted':'denied',
                      'personalization_storage': component.cookies.marketing?'granted':'denied',
                      'security_storage': component.cookies.marketing?'granted':'denied',
                  });
                } catch (error) {
                  
                }
                
                component.closeCookiesBar();
                try {
                  // se periptwsi pou den einai anoixto re paidi m xes
                  component.hideModal('modal-cookies')  
                } catch (error) {
                  
                }
                
                },function (error) {
                  console.log(error);
              });
          })
          .catch(error => {
            console.error(error);
          });
    },
    getFrequencyCookie() {
      let cookie;
      const cookies = `; ${document.cookie}`;
      const parts = cookies.split(`; showCookiesBar=`);

      if (parts.length === 2) {
        cookie = parts.pop().split(';').shift();
      }

      return cookie;
    },
    setFrequencyCookie(value, days = 30) {
      const today = new Date();
      const expireDate = new Date(today.setDate(today.getDate() + days));
      document.cookie = `showCookiesBar=false; expires=${expireDate}`;
    },
    frequencyCookieExpired() {
      return (this.getFrequencyCookie() == null || this.getFrequencyCookie() === true)
    },
    closeCookiesBar() {
      this.showCookiesBar = false;
      this.setFrequencyCookie(true);
    },
    showModal(id) {
      const modalEl = document.getElementById(id);
      const modalIndex = this.modals.findIndex(element => element.id == id);

      if (modalIndex === -1) {
        const modalObject = new bsModal(modalEl, {
          keyboard: id === 'modal-cookies' ? false : true,
          backdrop: id === 'modal-cookies' ? 'static' : true
        });

        this.modals.push({
          'id': id,
          'object': modalObject
        });

        modalObject.show();
      } else {
        this.modals[modalIndex].object.show();
      }
    },
    hideModal(id) {
      const modalIndex = this.modals.findIndex(element => element.id == id);
      this.modals[modalIndex].object.hide();
    },
  },
}
</script>

<style lang="scss">
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
}

.fade-bottom-enter,
.fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.modal-body-content {
  background-color: #fff;
  padding: 40px 60px 60px;
  box-shadow: 0px -10px 20px rgba(#000, 0.3);
}

.cookies-bar {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 15px 10px 5px;
  z-index: 1000;
  box-shadow: 0px -10px 20px rgba(#000, 0.3);

  .message {
    p {
      font-size: 12px;
      letter-spacing: 0.025rem;
      text-align: center;
    }
  }

  .buttons {
    margin: 10px 15px;
    text-align: center;

    .btn {
      border-width: 1px;
      border-style: solid;
      font-size: 0.725rem;
      padding: 10px 15px;
      line-height: 1;
      margin: 5px 0.5rem;
    }

    .btn-underline {
      text-decoration: underline;
      background: transparent;
      font-size: 12px;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.cookies-title {
  text-align: center;
  font-size: 30px;
  margin-bottom: 40px;
}

.btn-accept-decline {
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: column;
  margin-bottom: 60px;

  .btn-accept-decline-switch {
    position: relative;
    border: 1px solid;
    border-radius: 34px;
    transition: 400ms;
    display: flex;
    align-items: center;

    &::before {
      position: absolute;
      content: "";
      left: 0%;
      top: 50%;
      transform: translateY(-50%);
      width: 50%;
      height: 100%;
      background-color: #073d56;
      border-radius: 34px;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      transition: left 250ms ease-in-out;
    }

    .switch-label {
      padding: 8px 5px;
      width: 70px;
      font-size: 15px;
      text-align: center;
      position: relative;
      transition: color 250ms ease-in-out;
    }
  }

  &.accept {
    .btn-accept-decline-switch {
      .switch-label:nth-child(1) {
        color: #fff;
      }
    }
  }

  &.decline {
    .btn-accept-decline-switch {
      &::before {
        left: 50%;
      }
    }

    .btn-accept-decline-switch {
      .switch-label:nth-child(2) {
        color: #fff;
      }
    }
  }

  // &:disabled {
  //   .btn-accept-decline-switch {
  //     &::before {
  //       background-color: #9a9285;
  //     }
  //   }
  // }

  // &:hover:not([disabled]) {
  //   .btn-accept-decline-switch {
  //     opacity: 0.7;
  //   }
  // }

  .descr {
    margin-top: 20px;
    text-align: center;

    .descr-title {
      line-height: 1.5;
      font-size: 18px;
    }

    .descr-text {
      margin-top: 5px;
      line-height: 1.5;
      font-size: 12px;
    }
  }

  &:disabled {
    color: #000;
  }
}

.btn-discard-cookies {
  text-align: center;

  i {
    color: #000;

    &::before {
      font-size: 40px;
    }
  }

  span {
    display: block;
    color: #000;
    letter-spacing: 0.025rem;
    line-height: 1;
    font-size: 0.75rem;
  }
}

.btn-save-wrapper {
  text-align: center;

  .btn-save-cookies {
    font-size: 0.9375rem;
    font-weight: 400;
    padding: 18px 54px;
    border-radius: 50px;
    transition: opacity 250ms ease-in-out;

    &:hover {
      background: transparent;
      opacity: 0.6;
    }
  }
}

#modal-policy {
  .btn-modal-close {
    font-size: 70px;
  }
}

@media only screen and (min-width: 700px) {
  .cookies-bar {
    bottom: 0px;
  }

  .btn-accept-decline {
    flex-flow: row;

    .descr {
      margin-top: 0px;
      margin-left: 20px;
      text-align: left;
    }
  }
}

@media only screen and (min-width: 1200px) {
  .cookies-bar {
    box-shadow: 0px 0px 20px rgba(#000, 0.3);
    right: unset;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    max-width: 500px;
    padding: 20px 20px 10px;
  }
}
</style>